module.exports = __webpack_public_path__ + "634d767d2eb0bd01d47930a3a63f3d63.svg";